import { CarouselQuotes } from '@bumble/ui-kit';

export default function QuoteCarousel({ data }: { data: any }) {
  const { badgeText, quotes, linkText, imagePosition } = data || {};

  const sanitisedQuotes = quotes?.map((quote: any) => ({
    quote: quote?.quote,
    author: quote?.author,
    imageSrc: quote?.image?.responsiveImage?.src,
    imageAlt: quote?.image?.responsiveImage?.alt,
    link: quote?.link,
  }));

  return (
    <CarouselQuotes
      quotes={sanitisedQuotes}
      linkText={linkText}
      badgeText={badgeText}
      imagePosition={imagePosition}
    />
  );
}
